/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JourneyElementSeat } from './journeyElementSeat';
import { JourneyElementAcceptanceEligibility } from './journeyElementAcceptanceEligibility';

/**
 * 搭乗者ごとの情報<br>項目名は搭乗者のID
 */
export interface JourneyElement {
  /**
   * セグメント・搭乗者ごとのID
   */
  id: string;
  /**
   * 予約番号
   */
  orderId?: string;
  /**
   * 搭乗者およびセグメントの情報をもとにAltea Web Serviceから取得した航空券番号
   */
  eTicketNumber: string;
  seat: JourneyElementSeat;
  acceptanceEligibility: JourneyElementAcceptanceEligibility;
  /**
   * チェックインステータス<br> accepted：チェックイン済み<br> standBy：スタンバイチェックイン<br> notAccepted：未チェックイン（チェックイン失敗の場合も含む）
   */
  checkInStatus: JourneyElement.CheckInStatusEnum;
  /**
   * 搭乗券発行ステータス<br> printed: 搭乗券発行済み（発行済み、かつチェックイン済み）<br> standByPrinted: スタンバイ搭乗券発行済み（発行済み、かつスタンバイチェックイン済み）<br> notPrinted: 未発行（再発行要の場合も含む）
   */
  boardingPassPrintStatus?: JourneyElement.BoardingPassPrintStatusEnum;
  /**
   * 予約ステータスコード
   */
  bookingStatusCode?: string;
  /**
   * Selectee制限あり（Selectee制限ありの場合にtrue）
   */
  isSelectee: boolean;
  /**
   * 搭乗券発行可であるか<br> 以下の条件すべてに合致する場合にtrue    |No|条件|   |---:|:---|   |1|このjourneyElementが1便目に紐づく場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である|   |2|このjourneyElementが2便目以降に紐づく場合、操作時間が設定ファイルに定義した「分」単位の搭乗券発行可能時間の範囲内である、または直前の便が未出発である|   |3|このjourneyElement以前にSelectee制限を保有しない|   |4|チェックイン済みまたはスタンバイチェックイン済みである|   |5|NHグループ運航NHグループ便名、かつ席あり幼児を制限しているACV・キャビンクラスの便がjourney内に1便でも存在するときに、搭乗者に席あり幼児（INS）が存在しない|   |6|未発券のセグメントが存在しない搭乗者である|   |7|複数チェックイン対象便があり、1便目が未チェックインのときに、2便目以降がチェックイン済みでない<br>かつ、複数チェックイン対象便があり、未チェックインが間に存在しない|   |8|SKにPRIS/ARMDが存在しない|   |9|搭乗者がHigh Priority制限を保持しない、かつ以下のいずれにも該当しない<br>1. Acceptance comment(ACC)が登録されている<br>2. Next comment(NXT)が登録されている|   |10|SSR EXSTおよびSSR CBBGが存在しない|
   */
  isBoardingPassIssuanceEligible: boolean;
  /**
   * キャビンクラス
   */
  cabin?: string;
}
export namespace JourneyElement {
  export type CheckInStatusEnum = 'accepted' | 'standBy' | 'notAccepted';
  export const CheckInStatusEnum = {
    Accepted: 'accepted' as CheckInStatusEnum,
    StandBy: 'standBy' as CheckInStatusEnum,
    NotAccepted: 'notAccepted' as CheckInStatusEnum,
  };
  export type BoardingPassPrintStatusEnum = 'printed' | 'standByPrinted' | 'notPrinted';
  export const BoardingPassPrintStatusEnum = {
    Printed: 'printed' as BoardingPassPrintStatusEnum,
    StandByPrinted: 'standByPrinted' as BoardingPassPrintStatusEnum,
    NotPrinted: 'notPrinted' as BoardingPassPrintStatusEnum,
  };
}
